import { render, staticRenderFns } from "./GeneralLogs.vue?vue&type=template&id=e3990eec"
import script from "./GeneralLogs.vue?vue&type=script&lang=js"
export * from "./GeneralLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports